import { useGetRiskFactorsByCancer } from '@/queries/risk.queries';
import { RiskFactor, RiskFactorType } from '@/repositories/risk.repository';
import { useDisclosure } from '@cmpsr/components';
import { useState } from 'react';

export default function useRiskFactorModal() {
  const {
    isOpen: showModalDetailRiskFactor,
    onOpen: onOpenModalDetailRiskFactor,
    onClose: onHideModalDetailRiskFactor,
  } = useDisclosure();
  const { data: riskFactorsHookData } = useGetRiskFactorsByCancer();
  const [selectedRiskFactor, setSelectedRiskFactor] = useState<RiskFactor | null>(null);
  const [impactsByCancerType, setImpactsByCancerType] = useState<Record<string, number>>({});

  const affectedCancerTypes = selectedRiskFactor
    ? selectedRiskFactor.riskFactorType === RiskFactorType.nonQuantifiablePositive ||
      selectedRiskFactor.riskFactorType === RiskFactorType.nonQuantifiableNegative
      ? ['overall']
      : Object.keys(impactsByCancerType).filter((cancerType) => impactsByCancerType[cancerType] !== undefined)
    : [];

  const updateImpactsByCancerType = (label: string) => {
    const impacts =
      riskFactorsHookData?.factorsPerCancer
        .filter(({ cancerType }) => cancerType !== 'overall')
        .reduce<Record<string, number>>((acc, { cancerType, riskFactors }) => {
          const factor = riskFactors.find((factor) => factor.label === label);
          if (factor) {
            acc[cancerType] = factor.impact / 100;
          }
          return acc;
        }, {}) || {};

    const positiveImpacts = Object.entries(impacts).filter(([_, impact]) => impact > 0);
    const negativeImpacts = Object.entries(impacts).filter(([_, impact]) => impact < 0);

    const sortedPositiveImpacts = positiveImpacts.sort(([, impactA], [, impactB]) => impactB - impactA);

    const sortedNegativeImpacts = negativeImpacts.sort(([, impactA], [, impactB]) => impactA - impactB);

    const combinedImpacts = [...sortedPositiveImpacts, ...sortedNegativeImpacts];

    const sortedImpactsObject = Object.fromEntries(combinedImpacts);

    setImpactsByCancerType(sortedImpactsObject);
  };

  const handleOpenModal = (factor: RiskFactor) => {
    setSelectedRiskFactor(factor);
    updateImpactsByCancerType(factor.label);
    onOpenModalDetailRiskFactor();
  };

  return {
    showModalDetailRiskFactor,
    onHideModalDetailRiskFactor,
    handleOpenModal,
    selectedRiskFactor,
    affectedCancerTypes,
    impactsByCancerType,
  };
}
